<!--
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2025-11-17 14:21:50
 * @LastEditors: ckj kaijun.cui@biz-united.com.cn
 * @LastEditTime: 2025-11-17 16:17:36
 * @Description:
-->
<script>
import { download } from '@/found/utils/index.js';
import TablePage from '../../../../../components/table_page';
import request, { portUrl } from '../../../../../utils/request';
import ExportModal from '../../../../../components/export_modal';

export default {
  name: 'table-component',
  extends: TablePage,
  components: {
    ExportModal,
  },
  data() {
    return {
      formConfig: {},
      requestType: 'POST',
      modalConfig: {
        title: '查看附件',
        visible: false,
        type: '',
      },
      options: [],
    };
  },
  async created() {
    await this.getConfigList('main_list');
  },
  methods: {
    async getDict() {
      const resData = await request.get('/mdm/mdmdictdata/dictTree', {
        dictTypeCode: 'file_type',
      });
      this.options = resData.result;
    },
    clickVisible({ row, val: { code } }) {
      if (code === 'download') {
        return row.taskStatus === 2;
      }
      return true;
    },
    modalClick({ val, row }) {
      if (val.code === 'download') {
        download(row.fileUrl);
      }
    },
    // 查看进度
    prograssClick({ val, row }) {
      this.modalName = 'ExportModal';
      let fileParam = {};
      let configCode = '';
      if (row.fileType === '0') {
        configCode = row.fileParam;
        fileParam.sid = row.webSocketId;
      } else {
        fileParam = JSON.parse(row.fileParam);
      }
      this.propsObjInData = {
        code: val.code,
        row,
        ...fileParam,
        configCode,
        visible: true,
        exportMessage: '',
        isExport: row.fileType !== '0',
      };
    },
  },
};
</script>
